import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <img 
              src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/f34ba2532ff159722b540fefc621ff3a.png" 
              alt="Haruka Fitness" 
              className="h-10 sm:h-12 w-auto"
            />
          </div>
          <button
            onClick={scrollToContact}
            className="bg-[#F04D7A] text-white px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-sm sm:text-base font-medium hover:bg-[#E03A68] transition-all whitespace-nowrap cursor-pointer"
          >
            LINE相談する
          </button>
        </div>
      </nav>

      {/* Hero Section - Problem */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/59e1bf6a97cd4664b1f0a877f9a3d4ca.jpeg"
            alt="フィットネスで輝く女性"
            className="w-full h-full object-cover object-[85%_center]"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-32 w-full">
          <div className="max-w-2xl">
            <div className="space-y-6 sm:space-y-8 animate-fade-in bg-white/25 backdrop-blur-sm p-6 sm:p-8 rounded-3xl shadow-2xl">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#1A1A1A] leading-tight">
                30代を過ぎてから、<br />
                こんなお悩み<br />
                ありませんか?
              </h2>
              
              <div className="space-y-3 sm:space-y-4">
                {[
                  '昔と同じ食事なのに体重が増える...',
                  'ジムに通っても続かなかった',
                  '糖質制限で一時的に痩せても、すぐリバウンド',
                  '家事や育児で自分の時間が取れない',
                  '一人では続けられる自信がない'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-2 sm:gap-3 animate-slide-in" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="w-2 h-2 bg-[#F04D7A] rounded-full mt-2 sm:mt-2.5 flex-shrink-0"></div>
                    <p className="text-base sm:text-lg text-[#333333] font-medium">{item}</p>
                  </div>
                ))}
              </div>

              <button
                onClick={scrollToContact}
                className="bg-[#F04D7A] text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold hover:bg-[#E03A68] transition-all flex items-center gap-2 sm:gap-3 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer animate-pulse-soft"
              >
                <i className="ri-line-fill text-xl sm:text-2xl"></i>
                相談してみる
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Affinity Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 items-center">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/81b576eae4ebcfc268900d8906e0ba74.jpg"
                  alt="トレーニング風景"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="space-y-4 sm:space-y-6">
              <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] leading-tight">
                私も、同じ悩みを<br />
                抱えていました
              </h3>
              
              <div className="space-y-4 sm:space-y-5 text-base sm:text-lg text-[#333333] leading-loose">
                <p>家事や育児で自分の時間は後回し。<br />気づけば体型も崩れて、鏡を見るのが辛い日々...</p>
                
                <p>でも、<span className="relative inline-block">
                  <span className="relative z-10">「このままじゃいけない」</span>
                  <span className="absolute bottom-0 left-0 w-full h-2 bg-[#F04D7A]/30"></span>
                </span>って<br />心のどこかで思っていますよね。</p>
                
                <p className="font-bold text-lg sm:text-xl text-[#1A1A1A]">大丈夫です。<br />あなたは一人じゃありません。</p>
                
                <p><span className="relative inline-block">
                  <span className="relative z-10 font-bold">二人三脚</span>
                  <span className="absolute bottom-0 left-0 w-full h-2 bg-[#F04D7A]/30"></span>
                </span>で<br />あなたの「なりたい自分」を<br />一緒に叶えます。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 sm:py-24 bg-[#FFF8FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-[#1A1A1A] mb-3 sm:mb-4">
            ハルカフィットネスが選ばれる
          </h3>
          <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[#F04D7A] mb-12 sm:mb-16">3つの理由</p>

          <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                icon: 'ri-heart-3-fill',
                title: '30代以上の方に寄り添う',
                description: '大手ジムの無機質な雰囲気とは違い、一人ひとりの悩みに寄り添います。「痩せたい」だけじゃない、あなたの想いを大切にします。'
              },
              {
                icon: 'ri-restaurant-2-fill',
                title: '続けられる食事管理',
                description: '極端な糖質制限はしません。LINEで食事の写真を送るだけで、無理なく続けられるアドバイスを毎日お届けします。'
              },
              {
                icon: 'ri-boxing-fill',
                title: '正しいトレーニング',
                description: 'あなたの体力や目標に合わせたオーダーメイドプログラム。運動が苦手でも大丈夫。一つひとつ丁寧に指導します。'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 sm:p-10 shadow-lg hover:shadow-xl transition-all hover:-translate-y-2">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#F04D7A] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto">
                  <i className={`${item.icon} text-white text-2xl sm:text-3xl`}></i>
                </div>
                <h4 className="text-xl sm:text-2xl font-bold text-[#1A1A1A] mb-3 sm:mb-4 text-center">{item.title}</h4>
                <p className="text-sm sm:text-base text-[#666666] leading-relaxed text-center">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-[#1A1A1A] mb-3 sm:mb-4">
            変わった自分に出会えた
          </h3>
          <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[#F04D7A] mb-12 sm:mb-16">お客様の声</p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                initial: 'M.T',
                age: '40代・主婦',
                text: '3ヶ月で-8kg達成しました!無理な食事制限がなく、LINEでいつでも相談できるから続けられました。今では好きな服が着られるようになって、毎日が楽しいです。'
              },
              {
                initial: 'Y.S',
                age: '35歳・会社員',
                text: 'LINEで相談できるから安心です。仕事が忙しくても、隙間時間にメッセージを送れば丁寧にアドバイスしてくれます。温かいサポートに感謝しています。'
              },
              {
                initial: 'K.S',
                age: '50代・主婦',
                text: '話しやすい雰囲気で安心しました。更年期の悩みも理解してくれて心強いです。無理なく続けられるプログラムで、体調も良くなりました。'
              },
              {
                initial: 'A.Y',
                age: '38歳・主婦',
                text: '好きな服が着られるようになりました!産後太りで諦めていたワンピースが着られた時は涙が出ました。自分に自信が持てるようになって、人生が変わりました。'
              },
              {
                initial: 'R.T',
                age: '42歳・パート',
                text: '食事制限が苦じゃなくなりました。今まで我慢ばかりでストレスでしたが、指導は無理がなく、食べることが楽しくなりました。体重も順調に減っています。'
              },
              {
                initial: 'N.I',
                age: '45歳・主婦',
                text: '自分に自信が持てるようになりました。鏡を見るのが嫌だった私が、今では毎日体型チェックが楽しみです。家族からも「綺麗になったね」と言われて嬉しいです。'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
                <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#FDE8EF] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-smile-line text-[#F04D7A] text-xl sm:text-2xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-base sm:text-lg text-[#1A1A1A]">{testimonial.initial}</p>
                    <p className="text-xs sm:text-sm text-[#666666]">{testimonial.age}</p>
                  </div>
                </div>
                <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
                  <i className="ri-double-quotes-l text-[#F04D7A] text-lg sm:text-xl mr-1"></i>
                  {testimonial.text}
                  <i className="ri-double-quotes-r text-[#F04D7A] text-lg sm:text-xl ml-1"></i>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Offer Section */}
      <section className="py-16 sm:py-24 bg-gradient-to-br from-[#F04D7A] to-[#F56B8E]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            LINEで繋がる安心サポート
          </h3>
          <p className="text-lg sm:text-xl text-white/90 mb-8 sm:mb-12">予約の手間なし、食事の写真を送るだけ</p>

          <div className="grid md:grid-cols-3 gap-4 sm:gap-6 mb-8 sm:mb-12">
            {[
              {
                icon: 'ri-smartphone-fill',
                title: 'いつでも相談',
                description: '疑問や不安をすぐに解消'
              },
              {
                icon: 'ri-camera-fill',
                title: '食事管理が簡単',
                description: '写真を送るだけでアドバイス'
              },
              {
                icon: 'ri-calendar-check-fill',
                title: '予約もスムーズ',
                description: 'LINEで完結、電話不要'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
                <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className={`${item.icon} text-[#F04D7A] text-5xl sm:text-6xl`}></i>
                </div>
                <h4 className="text-lg sm:text-xl font-bold text-[#1A1A1A] mb-2">{item.title}</h4>
                <p className="text-xs sm:text-sm text-[#666666]">{item.description}</p>
              </div>
            ))}
          </div>

          <button
            onClick={scrollToContact}
            className="bg-white text-[#F04D7A] px-8 sm:px-12 py-4 sm:py-5 rounded-full text-lg sm:text-xl font-bold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 inline-flex items-center gap-2 sm:gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-2xl sm:text-3xl"></i>
            今すぐLINEで相談する
          </button>
          <p className="text-base sm:text-lg text-white/90 mt-4 sm:mt-5 font-medium">登録無料・相談無料</p>
        </div>
      </section>

      {/* Narrowing Down Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="border-2 border-dashed border-[#F8B8CC] rounded-3xl p-8 sm:p-12 text-center">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1A1A1A] mb-4 sm:mb-6 leading-tight">
              一人ひとりに寄り添うため<br />
              人数限定でのご案内です
            </h3>
            
            <div className="space-y-4 sm:space-y-5 text-base sm:text-lg text-[#333333] leading-loose">
              <p>ハルカフィットネスでは、<br />お一人お一人と真剣に向き合いたいから、<br />毎月のご案内人数に限りがあります。</p>
              
              <p className="text-lg sm:text-xl font-bold text-[#F04D7A]">
                「今月こそ変わりたい」<br />
                そう思った今が、始めるタイミングです。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section id="contact" className="py-16 sm:py-24 bg-gradient-to-b from-white to-[#FDE8EF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-4 sm:mb-6 leading-tight">
            まずは、<br className="sm:hidden" />お話ししませんか?
          </h3>
          
          <p className="text-base sm:text-xl text-[#666666] mb-8 sm:mb-12 leading-relaxed">
            無理な勧誘は一切ありません。<br />
            あなたのお悩みを聞かせてください。
          </p>

          <a
            href="https://line.me/R/ti/p/@harukafitness"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 sm:gap-4 bg-[#F04D7A] text-white px-8 sm:px-14 py-4 sm:py-6 rounded-full text-lg sm:text-2xl font-bold hover:bg-[#E03A68] transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer animate-pulse-soft w-full max-w-md mx-auto"
          >
            <i className="ri-line-fill text-2xl sm:text-4xl"></i>
            <span className="text-base sm:text-2xl">LINEで無料相談してみる</span>
          </a>
          
          <p className="text-xs sm:text-sm text-[#666666] mt-4 sm:mt-6 flex items-center justify-center gap-2">
            <i className="ri-arrow-down-line"></i>
            登録後、自動でメッセージが届きます
          </p>

          <div className="mt-12 sm:mt-16 pt-8 sm:pt-12 border-t border-gray-200">
            <div className="flex items-center justify-center gap-2 text-[#666666] mb-3 sm:mb-4">
              <i className="ri-map-pin-line text-lg sm:text-xl text-[#F04D7A]"></i>
              <p className="text-sm sm:text-base font-medium">アクセス</p>
            </div>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
              東京都立川市<br />
              JR立川駅 徒歩7分<br />
              <span className="text-xs sm:text-sm text-[#999999] mt-2 inline-block">※プライベートジムのため、詳細な住所はご予約時にお伝えします</span>
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#2B2B2B] text-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/f34ba2532ff159722b540fefc621ff3a.png" 
                alt="Haruka Fitness" 
                className="h-10 sm:h-12 w-auto mb-2"
              />
              <p className="text-xs sm:text-sm text-gray-400">あなたらしく、美しく</p>
            </div>

            <div>
              <h5 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">Follow Us</h5>
              <a
                href="https://www.instagram.com/haruka_fitness?igsh=d3R3a2JoNnpvMWsx&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-[#F04D7A] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl sm:text-2xl"></i>
                <span className="text-xs sm:text-sm">Instagram</span>
              </a>
            </div>

            <div>
              <h5 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">Contact</h5>
              <a
                href="https://line.me/R/ti/p/@harukafitness"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs sm:text-sm text-gray-400 hover:text-[#F04D7A] transition-colors cursor-pointer"
              >
                LINE公式アカウント
              </a>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-400">
            <p>© 2025 Haruka Fitness. All rights reserved.</p>
            <div className="flex items-center gap-4 sm:gap-6">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">プライバシーポリシー</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
